import { render } from "./FormFinancingIncomeView.vue?vue&type=template&id=4d6bd6c4"
import script from "./FormFinancingIncomeView.vue?vue&type=script&lang=js"
export * from "./FormFinancingIncomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__